import { createTheme } from '@flowio/react-theme';
import { colors, fonts, fontSize, fontWeight, lineHeight, shadows } from '@flowio/design-tokens';
import backgroundColor from './color/background';
import borderColor from './color/border';
import borderRadius from './border/radius';
import buttonSize from './size/button';
import textColor from './color/text';
var theme = createTheme({
  border: {
    radius: borderRadius
  },
  buttons: {
    shadows: shadows.medium
  },
  confirm: {
    minButtonWidth: 'auto'
  },
  color: {
    background: backgroundColor,
    border: borderColor,
    icon: {
      menuItemSelectedIndicator: colors.blue[500]
    },
    text: textColor
  },
  palette: {
    negative: colors.red[600],
    positive: colors.green[500],
    primary: colors.blue[600],
    warning: colors.yellow[500],
    text: {
      primary: colors.neutral[900],
      secondary: colors.neutral[800],
      tertiary: colors.neutral[700]
    }
  },
  shadow: {
    focusRing: '0 0 0 2px #d6e0ff',
    tabButton: {
      active: "inset 0 0 0 1px ".concat(colors.blue[500])
    }
  },
  size: {
    button: buttonSize,
    grid: {
      columnGap: 10,
      rowGap: 10
    },
    height: {
      checkbox: {
        small: 12,
        medium: 16,
        large: 20
      },
      radioButton: {
        small: 14,
        medium: 18,
        large: 22
      },
      input: {
        small: 32,
        medium: 36,
        large: 44
      },
      floatingLabelInput: {
        outlined: {
          small: 32,
          medium: 36,
          large: 44
        },
        stacked: {
          small: 44,
          medium: 50,
          large: 56
        }
      }
    },
    width: {
      checkbox: {
        small: 12,
        medium: 16,
        large: 20
      },
      radioButton: {
        small: 14,
        medium: 18,
        large: 22
      }
    },
    padding: {
      input: {
        small: {
          horizontal: 12,
          vertical: 10
        },
        medium: {
          horizontal: 12,
          vertical: 10
        },
        large: {
          horizontal: 12,
          vertical: 10
        }
      },
      floatingLabelInput: {
        outlined: {
          small: {
            base: {
              horizontal: 12,
              vertical: 10
            }
          },
          medium: {
            base: {
              horizontal: 12,
              vertical: 10
            }
          },
          large: {
            base: {
              horizontal: 12,
              vertical: 10
            }
          }
        },
        stacked: {
          small: {
            base: {
              vertical: 10,
              horizontal: 12
            },
            floating: {
              top: 20,
              bottom: 6
            }
          },
          medium: {
            base: {
              vertical: 10,
              horizontal: 12
            },
            floating: {
              top: 22,
              bottom: 7
            }
          },
          large: {
            base: {
              vertical: 10,
              horizontal: 12
            },
            floating: {
              top: 26,
              bottom: 10
            }
          }
        }
      },
      notch: 4
    }
  },
  spacing: {
    xs: 4,
    sm: 8,
    md: 10,
    lg: 12,
    xl: 16
  },
  typography: {
    h1: {
      fontFamily: fonts.heading,
      fontSize: fontSize[900],
      fontWeight: fontWeight.regular,
      lineHeight: lineHeight[900]
    },
    h2: {
      fontFamily: fonts.heading,
      fontSize: fontSize[800],
      fontWeight: fontWeight.regular,
      lineHeight: lineHeight[800]
    },
    h3: {
      fontFamily: fonts.heading,
      fontSize: fontSize[700],
      fontWeight: fontWeight.regular,
      lineHeight: lineHeight[700]
    },
    h4: {
      fontFamily: fonts.heading,
      fontSize: fontSize[600],
      fontWeight: fontWeight.regular,
      lineHeight: lineHeight[600]
    },
    h5: {
      fontFamily: fonts.heading,
      fontSize: fontSize[500],
      fontWeight: fontWeight.regular,
      lineHeight: lineHeight[500]
    },
    h6: {
      fontFamily: fonts.heading,
      fontSize: fontSize[400],
      fontWeight: fontWeight.regular,
      lineHeight: lineHeight[400]
    },
    body: {
      fontFamily: fonts.heading,
      fontSize: fontSize[200],
      fontWeight: fontWeight.regular,
      lineHeight: lineHeight[200]
    },
    banner: {
      text: {
        fontFamily: fonts.body,
        fontWeight: fontWeight.bold,
        fontSize: fontSize[100],
        lineHeight: lineHeight[100]
      },
      title: {
        fontFamily: fonts.heading,
        fontWeight: fontWeight.medium,
        fontSize: fontSize[200],
        lineHeight: lineHeight[200]
      }
    },
    button: {
      small: {
        fontFamily: fonts.heading,
        fontWeight: fontWeight.bold,
        fontSize: fontSize[200],
        lineHeight: lineHeight[200]
      },
      medium: {
        fontFamily: fonts.heading,
        fontWeight: fontWeight.bold,
        fontSize: fontSize[300],
        lineHeight: lineHeight[300]
      },
      large: {
        fontFamily: fonts.heading,
        fontWeight: fontWeight.bold,
        fontSize: fontSize[500],
        lineHeight: lineHeight[500]
      }
    },
    caption: {
      fontFamily: fonts.heading,
      fontSize: fontSize[100],
      fontWeight: fontWeight.regular,
      lineHeight: lineHeight[200]
    },
    input: {
      small: {
        fontFamily: fonts.body,
        fontSize: fontSize[300],
        fontWeight: fontWeight.regular,
        lineHeight: lineHeight[300]
      },
      medium: {
        fontFamily: fonts.body,
        fontSize: fontSize[300],
        fontWeight: fontWeight.regular,
        lineHeight: lineHeight[300]
      },
      large: {
        fontFamily: fonts.body,
        fontSize: fontSize[300],
        fontWeight: fontWeight.regular,
        lineHeight: lineHeight[300]
      }
    }
  }
});
export default theme;